module.exports = __webpack_public_path__ + "static/media/reglamento_2.68684471.png";